export default "__VITE_ASSET__CVcSC3aU__"